import React from 'react'
import AvatarImage from '../AvatarImage'

/**
 * User model matching backend UserViewModel from CodeItemsHub
 */
export interface ActiveUser {
  id: string
  name: string
  emailAddress: string
  avatarUri?: string | null
}

interface ActiveUsersIndicatorProps {
  users: ActiveUser[]
  maxVisible?: number
  size?: number
  className?: string
  title?: string
}

export const ActiveUsersIndicator: React.FC<ActiveUsersIndicatorProps> = ({
  users,
  maxVisible = 4,
  size = 32,
  className = '',
  title = 'Currently editing'
}) => {
  if (users.length === 0) {
    return null
  }

  const visibleUsers = users.slice(0, maxVisible)
  const remainingCount = users.length - maxVisible

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-600 font-medium">{title}:</span>
      <div className="flex -space-x-2">
        {visibleUsers.map((user, idx) => (
          <div
            key={user.id || idx}
            title={`${user.name || 'Unknown user'}${user.emailAddress ? ` (${user.emailAddress})` : ''}`}
            className="rounded-full border-2 border-white shadow-sm"
            style={{ width: size, height: size }}
          >
            <AvatarImage
              name={user.name || ''}
              filename={user.avatarUri || null}
              size={size}
            />
          </div>
        ))}
        {remainingCount > 0 && (
          <div
            className="rounded-full bg-gray-300 border-2 border-white flex items-center justify-center text-gray-700 text-xs font-semibold shadow-sm"
            style={{ width: size, height: size }}
            title={`${remainingCount} more user${remainingCount > 1 ? 's' : ''}`}
          >
            +{remainingCount}
          </div>
        )}
      </div>
    </div>
  )
}

